const baseUrl = '/api/v1'

export const API = {
    login: `${baseUrl}/email/login`,
    users: `${baseUrl}/user/all`,
    waves: `${baseUrl}/wave/all`,
    htmlDetail: `${baseUrl}/html`,
    createWave: `${baseUrl}/api/v1/wave/create`,
    chats: `${baseUrl}/wave/message/single`,
    comments: `${baseUrl}/wave/list/waveID/comments`,
    mapSnapshot: `${baseUrl}/wave/WAVE_ID/map`, // 地图快照API路径
    exploreWaves: `${baseUrl}/html/explore`, // PC页面探索活动API（无需登录）
    citiesStats: `${baseUrl}/wave/cities/stats`, // 与iOS相同的城市统计API
    waveDetail: `${baseUrl}/html/wave`, // PC页面活动详情API（无需登录）
    homeCarousel: `${baseUrl}/html/home/carousel`, // PC首页轮播数据API（无需登录）
};
